export default class UserRoleSerializer {
  static serialize(data) {
    return {
      roleName: data.roleName,
      roleId: data.roleId,
      dateCreated: data.dateCreated,
      dateModified: data.dateModified
    };
  }

  static deSerialize(data) {
    return {
      roleName: data.roleName,
      roleId: data.roleId,
      dateCreated: data.dateCreated,
      dateModified: data.dateModified
    };
  }
}